import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";

export function Nav() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleAuthAction = () => {
    if (currentUser) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm w-full">
      <div className="container mx-auto flex items-center py-4">
        <div className="w-[150px]">
          <a href="/">
            <img src="/Favicon.png" alt="KinAlma" className="h-10" />
          </a>
        </div>
        <div className="flex-1 flex justify-center">
          <div className="hidden items-center gap-8 md:flex">
            <Link
              to="/privacy-policy"
              className="text-lg font-medium text-gray-500 hover:text-pink-400 transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        <div className="w-[150px] flex justify-end">
          <button
            className="font-medium bg-transparent border-none cursor-pointer text-lg flex items-center gap-2"
            onClick={handleAuthAction}
          >
            {currentUser ? (
              <>
                Dashboard <span className="text-xl">→</span>
              </>
            ) : (
              "Log in"
            )}
          </button>
        </div>
      </div>
    </nav>
  );
}